<div class="select-dropdown">
  <label
    *ngIf="label && label?.length > 0"
    class="align-dropdown-label"
    title="{{ label }}"
    [ngClass]="{ 'small-labels': smallSelect, 'header-labels': headerSelect }"
    >{{ label }}<span *ngIf="required" class="color-red" title="Required"> *</span></label
  >
  <div class="dropdown">
    <a
      class="btn dropdown-toggle btn-sm default-font"
      [ngClass]="{
        invalid: !selected?.label && required && changed,
        valid: selected?.label && required && changed,
        'small-labels-selected': smallSelect,
        'header-labels-selected': headerSelect,
      }"
      role="button"
      id="{{ id }}"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
      tabindex="{{ tab }}"
      [class.disabled]="disabled ? true : null"
    >
      <span
        class="selected-value"
        [ngClass]="{ 'header-labels-selected': headerSelect }"
        title="{{ selected?.label ? selected?.label : placeholder }}"
        >{{ selected?.label ? selected?.label : placeholder }}</span
      >
    </a>

    <div class="dropdown-menu" attr.aria-labelledby="{{ id }}">
      <span *ngIf="!noblank"
        ><a
          class="dropdown-item default-pointer"
          [ngClass]="{ 'small-labels': smallSelect, 'header-labels': headerSelect }"
          (click)="selectOption({})"
          id="none"
          title="none"
        ></a
      ></span>
      <div *ngIf="noblank && placeholder.length > 0" class="placeholder">
        <a
          class="dropdown-item placeholder"
          (click)="selectOption({})"
          id="none"
          title="{{ placeholder }}"
          [ngClass]="{ 'small-labels': smallSelect, 'header-labels': headerSelect }"
          >{{ placeholder }}</a
        >
      </div>
      <span *ngFor="let option of options; index as i">
        <a
          class="dropdown-item default-pointer"
          [ngClass]="{
            'active-selection': selected.value === option.value,
            'small-labels': smallSelect,
            'header-labels': headerSelect,
            disabled: checkDisabled(option?.value),
          }"
          (click)="selectOption(option)"
          title="{{ option?.label }}"
          id="{{ i }}"
          >{{ option?.label }}</a
        >
      </span>
    </div>
  </div>
</div>
